import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import ListAppContentPackages from '../app-content/list-app-content-packages.component';

const AppWebsiteIAPPlans = ({ channelDetail, viewMode }) => (
  <Box component={Paper} p={2} width="100%">
    <ListAppContentPackages channelId={channelDetail.id} viewMode={viewMode} />
  </Box>
);

AppWebsiteIAPPlans.propTypes = {
  channelDetail: PropTypes.object.isRequired,
  viewMode: PropTypes.bool,
};
AppWebsiteIAPPlans.defaultProps = {
  viewMode: false,
};

export default AppWebsiteIAPPlans;
